import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { FormControl, FormGroup, Stack, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { isNotEmpty } from "../../utils";
import { PasswordField } from "../../controls";

export interface RepeatPasswordControlProps {
  required: boolean;
  onChange?: (value: string, isValid: boolean) => void;
}

export const RepeatPasswordControl = (props: RepeatPasswordControlProps) => {
  const { required, onChange } = props;

  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [isValid, setIsValid] = useState(true);

  const handleChange = (valid: boolean, value: string) => {
    setIsValid(valid);
    if (onChange) onChange(valid ? value : "", valid);
  }

  const handlePasswordChange = (value: string) => {
    setPassword(value);
    const valid = value === repeatPassword;
    handleChange(valid, value);
  };
  const handleRepeatPasswordChange = (value: string) => {
    setRepeatPassword(value);
    const valid = value === password;
    handleChange(valid, value);
  };

  useEffect(() => {
    setPassword("");
    setRepeatPassword("");
    setIsValid(true);
  }, []);

  return (
    <FormControl component="fieldset" sx={{ minWidth: 150 }}>
      <FormGroup>
        <Stack spacing={2} direction="row" alignItems="center">
          <Stack direction="column">
            <PasswordField label="Password" required={required} variant="standard" value={password} onChange={(e) => handlePasswordChange(e.target.value)} />
            <PasswordField
              label="Repeat password"
              required={required}
              variant="standard"
              value={repeatPassword}
              onChange={(e) => handleRepeatPasswordChange(e.target.value)}
            />
          </Stack>
          {isNotEmpty(password) && isValid && <CheckIcon htmlColor="green" />}
          {isNotEmpty(password) && !isValid && <ClearIcon htmlColor="red" />}
        </Stack>{" "}
      </FormGroup>
    </FormControl>
  );
};
